import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { Store } from "@ngrx/store";
import { selectToken } from "@state/selectors/user.selectors";
import { Observable } from "rxjs";

@Injectable()
export class JwtLocalApiInterceptor implements HttpInterceptor {
  private readonly token = this.store.selectSignal(selectToken);
  private readonly localApiBase = "http://localhost:3011";

  constructor(private readonly store: Store) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.token();
    const hasValidToken = typeof token === "string" && token.length > 0;
    const isLocalApiRequest =
      request.url.startsWith(this.localApiBase) ||
      request.url.startsWith(environment.api.mv.nf);

    if (
      !isLocalApiRequest ||
      !hasValidToken ||
      request.headers.has("Authorization")
    ) {
      return next.handle(request);
    }

    const requestWithToken = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });

    return next.handle(requestWithToken);
  }
}
